export const AffiliateStatus = [
  'CREATION',
  'ACTIVE',
  'INACTIVE',
  'CLOSED'
]
